import React from "react";

import { Tooltip } from "@material-ui/core";
import { OKIcon, LowInventoryAlertIcon } from "./iconography";
import { green, orange } from "@material-ui/core/colors";

export const LowInventoryIcon = ({ record, ...props }) => {
  if (!record) return null;

  const alert = record.lowInventoryAlert || record.product?.lowInventoryAlert;

  if (alert)
    return (
      <Tooltip title={`Low Inventory`} placement="right" arrow>
        <LowInventoryAlertIcon style={{ color: orange[600] }} />
      </Tooltip>
    );
  else
    return (
      <Tooltip title="Inventory Levels OK" placement="right" arrow>
        <OKIcon style={{ color: green[600] }} />
      </Tooltip>
    );
};
